const CloneProps = ({ children, ...other }: any) => {
    return children(other);
};

export default CloneProps;
